import React, { useContext } from 'react'

import { getEnvironment } from '../environment'

export const EnvironmentContext = React.createContext<string>(getEnvironment())

const useEnvironment = () => useContext(EnvironmentContext)!

export default useEnvironment
